module.exports = __webpack_public_path__ + "img/img-box-products-magento-2x-right.883a3a4d.png";